import React, { useEffect, useState } from 'react';
import { MDBContainer, } from 'mdb-react-ui-kit';
import BreadCrumbs from '../components/breadcrumbs';
import Banner from '../components/img_banner';
import Info from '../components/services_outsourcing-info';
import Desc from '../components/services_outsourcing_description';

import DownContact from '../components/downcontact';
import RCMcy from '../img/medicalbillingservices/Outsourcingservices/banner.jpg';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';
ReactGA.initialize('G-7WQFXCQFVP');

const MedicalBillingService = () => {
  useEffect(() => {
    // change title of page
    document.title = 'Professional Healthcare Medical Billing - USA - AcerHealth';
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-7WQFXCQFVP';
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());

    gtag('config', 'G-7WQFXCQFVP');
  }, []);

  // Set breadcrumb
  const [Breadcrumb, setBreadcrumb] = useState('Medical Billing Outsourcing Services ');

  // Set Banner Title
 const [BannerTitle, setBannerTitle] = useState({ 
  title: "Medical Billing Outsourcing Services in the USA", 
  img: `url(${RCMcy})`,
  altText: "Medical billing outsourcing services supporting U.S. healthcare practices with streamlined claims and revenue cycle management" 
});
  // Set DownContact Heading
  const [DownContactTitle, setDownContactTitle] = useState({ 
  title: "Ready to Outsource Medical Billing for Your U.S. Practice?",
  subtitle: "AcerHealth helps U.S. healthcare practices improve billing accuracy, reduce denials, and gain visibility through structured medical billing outsourcing." 
});

  return (
    <>
      <Helmet>
        <title>Medical Billing Outsourcing Services in the USA | AcerHealth</title>
        <link rel="canonical" href="https://acerhealth.com/services/medical-billing-outsourcing-services-usa" />
        <meta name="description" content="Outsource medical billing to AcerHealth for U.S. healthcare practices. HIPAA-compliant billing, denial reduction, and transparent reporting." />
        <meta name="keywords" content="Medical Billing Service" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "@id": "https://acerhealth.com/#organization",
                "name": "AcerHealth",
                "url": "https://acerhealth.com",
                "logo": "%PUBLIC_URL%/favicon.png",
                "description": "AcerHealth provides medical billing outsourcing services for U.S. healthcare practices, specializing in compliant, transparent, and scalable billing operations."
              },
              {
                "@type": "Service",
                "@id": "https://acerhealth.com/services/medical-billing-outsourcing-services-usa#service",
                "name": "Medical Billing Outsourcing Services in the USA",
                "serviceType": "Medical Billing Outsourcing",
                "provider": {
                  "@type": "Organization",
                  "@id": "https://acerhealth.com/#organization"
                },
                "areaServed": {
                  "@type": "Country",
                  "name": "United States"
                },
                "url": "https://acerhealth.com/services/medical-billing-outsourcing-services-usa",
                "description": "Medical billing outsourcing services designed for U.S. healthcare practices, including end-to-end billing management, denial reduction, HIPAA compliance, and transparent reporting."
              },
              {
                "@type": "FAQPage",
                "@id": "https://acerhealth.com/services/medical-billing-outsourcing-services-usa#faq",
                "mainEntity": [
                  {
                    "@type": "Question",
                    "name": "Who should use medical billing outsourcing services in the USA?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Medical billing outsourcing is ideal for U.S. healthcare practices seeking to reduce administrative burden, manage staffing challenges, and improve billing efficiency while maintaining compliance with payer and regulatory requirements."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Does AcerHealth provide medical billing outsourcing only for U.S. practices?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes. AcerHealth’s medical billing outsourcing services are designed exclusively for U.S. healthcare practices and aligned with U.S. payer rules, reimbursement models, and regulatory standards."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How does outsourcing medical billing improve cash flow?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Outsourcing medical billing helps improve cash flow by reducing claim errors, accelerating claim submission, and ensuring consistent follow-up on unpaid or denied claims through structured billing workflows."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Is medical billing outsourcing with AcerHealth HIPAA compliant?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes. AcerHealth follows HIPAA-compliant processes and security controls to protect patient data and billing information throughout the outsourcing engagement."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How long does it take to transition to medical billing outsourcing?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "The transition timeline depends on practice size and complexity, but AcerHealth follows a structured onboarding process to ensure a smooth and efficient transition with minimal disruption to billing operations."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Will I have visibility into my outsourced billing performance?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes. AcerHealth provides regular billing reports and performance visibility so practices can track claim status, denials, and reimbursement outcomes without managing day-to-day billing tasks."
                    }
                  }
                ]
              }
            ]
          }
          )}
        </script>
      </Helmet>
      {/* <BreadCrumbs Breadcrumb ={Breadcrumb} /> */}
      <Banner BannerTitle={BannerTitle} />
      <Info />
      <Desc />
      <DownContact DownContactTitle={DownContactTitle} />
      

    </>
  );
};

export default MedicalBillingService;